// jumpType
//0-无跳转，
//1-需登录跳M页无token，
//2-不需登录跳M页无token，
//3-需登录跳M页有Token，
//4-不需登录跳M页有token，
//5-需登录跳native页，
//6-不需登录跳native页，
//7-不登录跳M页无token，登录跳M页有Taoken，
//8-需登录跳M页有sid(统一登录)。(3.8.0)

import qs from 'qs';
const URL = window.location.href.substring(
    window.location.href.indexOf('?') + 1
);

const WIN = qs.parse(URL).win ? `&win=${qs.parse(URL).win}` : '';

const JUMP = jumpData => {
    let baseUrl = `//u2.jr.jd.com/downloadApp/index.html?id=2948${WIN}&jumpUrl=`;
    let downloadApp = baseUrl + encodeURIComponent(window.location.href);
    let jumpUrl = jumpData.jumpUrl || window.location.href;
    let jumpType = jumpData.jumpType || 8;
    let productId = jumpData.productId || '';
    // let islogin = jumpType == 5 ? true : false;
    // let param = jumpData.param || {};
    let islogin = false;

    let isRN = jumpType == 5 || jumpType == 6 ? true : false;

    let isJrApp =
        window.navigator.userAgent.toLowerCase().indexOf('jdjr') > -1 ||
        window.navigator.userAgent.toLowerCase().indexOf('android-async-http') >
            -1 ||
        false;

    let schemeUrl = jumpData.schemeUrl || null;
    if (schemeUrl) {
        if (isJrApp) {
            window.JrBridge.openScheme({
                schemeUrl: schemeUrl,
                jumpType: 6
            });
        } else {
            window.location.href = downloadApp;
        }
    } else {
        if (isRN) {
            if (isJrApp) {
                let config = {};
                if (jumpData.param) {
                    config = {
                        target: jumpUrl,
                        container: 'native',
                        productId: productId,
                        islogin: islogin,
                        isclose: false,
                        param: jumpData.param
                    };
                } else {
                    config = {
                        target: jumpUrl,
                        container: 'native',
                        productId: productId,
                        islogin: islogin,
                        isclose: false
                    };
                }
                window.JrBridge.openView(config);
            } else {
                window.location.href = downloadApp;
            }
        } else {
            if (jumpUrl == window.location.href) {
                window.location.reload();
                return;
            }

            if (isJrApp) {
                console.log(jumpUrl);
                // window.open(jumpUrl);
                if (window.JrBridge && window.JrBridge.openScheme) {
                    window.JrBridge.openScheme({
                        jumpType: '7',
                        jumpUrl: jumpUrl
                    });
                } else {
                    window.open(jumpUrl);
                }
            } else {
                window.location.href = jumpUrl;
            }
            // if (isJrApp) {
            //     window.JrBridge.openView({
            //         target: jumpUrl,
            //         container: 'h5',
            //         productId: productId,
            //         islogin: islogin,
            //         isclose: false,
            //         param: param
            //     });
            // } else {
            //     window.location.href = jumpUrl;
            // }
        }
    }
};

export default JUMP;
